export default __webpack_public_path__ + "static/media/reglages.0e1eb82a.svg";